export const CONTRACT_STATEMENT = "CONTRACT_STATEMENT";
